import { inject, Injectable, EventEmitter } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LogService } from './log.service';

@Injectable()
export class ApiHttpInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private logService: LogService
  ) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.logService.LogRequest(request.method, "", request.url, request.body);
    return next.handle(request).pipe(map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        event = event.clone({ body: event.body });
        this.logService.LogResponse(event.status.toString(), "", request.url, event.body);
      }
      return event;
    }));
  }
}
